<template>
  <b-tab :title="tabTitle">
    <br />
    <b-col sm="12" md="12">
      <transition name="fade">
        <b-card no-body>
          <b-collapse id="collapse1" visible>
            <b-tabs
              card
              pills
              vertical
              nav-wrapper-class="w-40"
              v-model="loanTabIndex[1]"
            >
              <b-tab active>
                <template slot="title">{{ loanTabs[0] }}
                  <span v-if="PersonalDetailsFormCompleted">✔</span>
                <span v-else class="text-danger">*</span>
                </template>
                <b-col sm="12">
                  <b-alert v-if="FormCompleted" show variant="primary"
                    >Bahagian ini telah lengkap. ✔</b-alert
                  >
                  <b-alert v-else show variant="warning"
                    >Bahagian ini tidak lengkap.</b-alert
                  >
                  <hr />
                </b-col>
                <b-form class="col-md-12">
                  <b-form class="col-md-12" ref="input">
                    <b-row>
                    <!-- <b-row v-if="$ProgramIdYTP!=ProgramId"> -->
                      <b-col sm="6">
                        <b-form-group label="Pertalian Dengan Pemohon (Jika berkaitan)" label-for="Relationship">
                          <Dropdown v-model="RelationshipName" :options="Relationship" optionLabel="Name" @change="setRelationshipIdGuarantor($event)" :filter="true" placeholder="Sila Pilih" :showClear="true" 
                            dataKey="Id" class="p-inputtext-sm" style="width:100%; box-sizing: border-box;" inputStyle="width: 100%; box-sizing: border-box;">
                            <template #value="slotProps">
                              <div v-if="slotProps.value">
                                <div>{{slotProps.value.Name}}</div>
                              </div>
                              <span v-else>
                                {{slotProps.placeholder}}
                              </span>
                            </template>
                            <template #option="slotProps">
                              <div>
                                <div>{{slotProps.option.Name}}</div>
                              </div>
                            </template>
                          </Dropdown>
                          <b>Nota: Jika penjamin bukan ibu/bapa sila isi maklumat di bawah.</b>
<!--
GUARANTOR ELIGIBILITY VALIDATION IN PROGRESS
<br>
OTHERS = {{others}}
<br>
ICF = {{IdentityNoFather}}
<br>
ICM = {{IdentityNoMother}}
<br>
ICG = {{IdentityNoGuardian}}
<br>
ICG1 = {{IdentityNoGuarantor1}}
<br>
ICG2 = {{IdentityNoGuarantor2}}
-->
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <hr v-if="$ProgramIdYTP!=ProgramId"/>
                    <b-row>
                      <b-col sm="6">
                        <b-form-group label-for="FullName">
                          <template v-slot:label>
                            Nama Seperti Dalam Kad Pengenalan
                            <span v-if="!FirstName" class="text-danger">*</span>
                            <span v-else>✔</span>
                          </template>
                          <b-form-input
                            type="text"
                            v-model.trim="FirstName"
                            @keyup="replaceInvertedComma()"
                            @change="replaceInvertedComma()"
                          />
                        </b-form-group>
                        <span
                          class="error"
                          v-show="FirstName && !replaceInvertedComma()"
                        >
                          <span style="color:red;">Nama tidak boleh mengandungi digit</span>
                          <hr />
                        </span>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="6">
                        <b-form-group label-for="IC">
                          <template v-slot:label>
                            No. Kad Pengenalan Baru
                            <span
                              v-if="!IdentityNo || !IsIdentityValid(IdentityNo) || !guarantorEligibility || !guarantorAgeEligibility"
                              class="text-danger"
                              >*</span
                            >
                            <span v-else>✔</span>
                          </template>
                          <b-form-input
                            type="text"
                            placeholder="Cth: 910821045224"
                            autocomplete="ic"
                            v-model.trim="IdentityNo"
                            maxlength="12"
                          ></b-form-input>
                          <span class="error" v-show="IdentityNo && !IsIdentityValid(IdentityNo)" >
                            <span style="color: red">
                              No. Kad Pengenalan tidak sah
                            </span>
                          </span>
                          <span class="error" v-show="!guarantorEligibility" >
                            <span style="color: red">
                              {{guarantorEligibilityValidationRemark}}
                            </span>
                          </span>
                          <span class="error" v-show="IsIdentityValid(IdentityNo) && !guarantorAgeEligibility" >
                            <span style="color: red">
                              {{guarantorAgeEligibilityRemark}}
                            </span>
                          </span>
                        </b-form-group>
                      </b-col>
                      <b-col sm="6">
                        <b-form-group label-for="IC Other">
                          <template v-slot:label>
                            No. Kad Pengenalan (Lama / Tentera / Lain-lain)
                            <span
                              v-if="wasBornBefore1977(IdentityNo) && !IdentityNoOther"
                              class="text-danger"
                              >*</span
                            >
                            <span v-else-if="wasBornBefore1977(IdentityNo) && IdentityNoOther">✔</span>
                          </template>
                          <b-form-input
                            type="text"
                            placeholder="Cth: 910821045224"
                            autocomplete="ic"
                            maxlength="20"
                            v-model="IdentityNoOther"
                          ></b-form-input>
                          <span class="error" v-show="wasBornBefore1977(IdentityNo) && !IdentityNoOther" >
                            <span style="color: red">
                              Pemegang No. Kad Pengenalan Baru yang bermula kurang dari 78 perlu memberikan No. Kad Pengenalan (Lama / Tentera / Lain-lain)
                            </span>
                          </span>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="6">
                        <b-form-group label-for="MonthlyIncome">
                          <template v-slot:label>
                            Pendapatan Sebulan (RM)
                            <span v-if="!MonthlyIncome || !guarantorIncomeEligibility" class="text-danger"
                              >*</span
                            >
                            <span v-else>✔</span>
                          </template>
                          <b-form-input
                            placeholder="0.00"
                            type="number"
                            min="0.00"
                            step="10.00"
                            v-model.trim="MonthlyIncome"
                          ></b-form-input>
                          <span class="error" v-show="!guarantorIncomeEligibility" >
                            <span style="color: red">
                              {{guarantorIncomeEligibilityRemark}}
                            </span>
                          </span>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-form>
              </b-tab>
              <b-tab>
                <template slot="title">{{ loanTabs[1] }}
                  <span v-if="ContactDetailsFormCompleted">✔</span>
                  <span v-else class="text-danger">*</span>
                </template>
                <ContactDetails :others="others" />
              </b-tab>
            </b-tabs>
          </b-collapse>
        </b-card>
      </transition>
    </b-col>
  </b-tab>
</template>

<script>
import DefaultOption from "./DefaultOption";
import ContactDetails from "./ContactDetails";
import Vue from "vue";
import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);
import Dropdown from 'primevue/dropdown';

export default {
  name: "GuarantorDetails",
  props: ["others"],
  components: {
    DefaultOption,
    ContactDetails,
    Dropdown,
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.GetBankDetails();
      this.GetPersonalDetails();
      this.GetEmploymentHistory();
      await this.getRelationship();
      if (0 == this.CountryId1) {
        await this.getProposedStudy();
      }
      this.readConfig();
    }
  },
  data: function () {
    return {
      loanTabIndex: [0, 0],
      loanTabs: ["Butiran Peribadi Penjamin",
                 "Maklumat Untuk Dihubungi"],
      Relationship: null,
      RelationshipName: null,
      RelationshipIdGuarantor: null,
      guarantorAgeEligibilityRemark: null,
      guarantorAgeEligibilityResult: null,
      guarantorEligibilityValidationRemark: null,
      guarantorEligibilityValidationResult: null,
      guarantorIncomeEligibilityRemark: null,
      guarantorIncomeEligibilityResult: null,
      guarantorMaxAge: null,
      guarantorMinMonthlyIncome: null,
      sCFN: 'GuarantorDetails: ',
    };
  },
  computed: {
    FormCompleted: {
      get: function () {
        let complete = true;
        if (this.others == "guarantor1") {
          if (this.FirstName == "" || this.IdentityNo == "" || this.MonthlyIncome == 0.00) complete = false;
        }
        if (this.others == "guarantor2") {
          if (this.FirstName == "" || this.IdentityNo == "" || this.MonthlyIncome == 0.00) complete = false;
        }
        if  ((null != this.IdentityNo)
          && (0 < this.IdentityNo.length)) {
          if (this.wasBornBefore1977(this.IdentityNo)) {
            if (null == this.IdentityNoOther) {
              complete = false;
            } else {
              if (0 == this.IdentityNoOther.length) {
                complete = false;
              }
            }
          }
        }
        if (0 == this.guarantorEligibilityValidationResult) {
          complete = false;
        }
        if (0 == this.guarantorIncomeEligibilityResult) {
          complete = false;
        }
        if (0 == this.guarantorAgeEligibilityResult) {
          complete = false;
        }
        this.$store.dispatch(this.others + "PersonalDetails/updateFormCompleted", complete);
        return complete;
      },
    },
    tabTitle: {
      get: function () {
        if (this.others == "guarantor1") 
          return "Penjamin 1";
        else 
          return "Penjamin 2";
      },
    },
    IdentityNo: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/IdentityNo"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateIdentityNo",
          value
        );
      },
    },
    IdentityNoOther: {
      get: function () {
        return this.$store.getters[
          this.others + "PersonalDetails/IdentityNoOther"
        ];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateIdentityNoOther",
          value
        );
      },
    },
    FirstName: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/FirstName"];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "PersonalDetails/updateFirstName",
          value
        );
      },
    },
    MonthlyIncome: {
      get: function () {
        return this.$store.getters[
          this.others + "EmploymentHistory/MonthlyIncome"
        ];
      },
      set: function (value) {
        this.$store.dispatch(
          this.others + "EmploymentHistory/updateMonthlyIncome",
          value
        );
      },
    },
    PersonalDetailsFormCompleted: {
      get: function() {
        return this.$store.getters[this.others + "PersonalDetails/FormCompleted"];
      }
    },
    ContactDetailsFormCompleted: {
      get: function() {
        return this.$store.getters[this.others + "ContactDetails/FormCompleted"];
      }
    },
    FatherContactInfo: {
      get: function() {
        let obj = {};
        obj.IdentityNo = this.$store.getters["fatherPersonalDetails/IdentityNo"];
        obj.IdentityNoOther = this.$store.getters["fatherPersonalDetails/IdentityNoOther"];
        obj.FirstName = this.$store.getters["fatherPersonalDetails/FirstName"];
        obj.MonthlyIncome = this.$store.getters["fatherEmploymentHistory/MonthlyIncome"];
        obj.FixPhoneNo = this.$store.getters["fatherContactDetails/FixPhoneNo"];
        obj.MobilePhoneNo = this.$store.getters["fatherContactDetails/MobilePhoneNo"];
        obj.FaxNo = this.$store.getters["fatherContactDetails/FaxNo"];
        obj.Email = this.$store.getters["fatherContactDetails/Email"];
        obj.NationalityId = this.$store.getters["fatherPersonalDetails/Nationality"];
        obj.AddressId = this.$store.getters["fatherPersonalDetails/PersonalAddress"];
        return obj;
      },
    },
    MotherContactInfo: {
      get: function() {
        let obj = {};
        obj.IdentityNo = this.$store.getters["motherPersonalDetails/IdentityNo"];
        obj.IdentityNoOther = this.$store.getters["motherPersonalDetails/IdentityNoOther"];
        obj.FirstName = this.$store.getters["motherPersonalDetails/FirstName"];
        obj.MonthlyIncome = this.$store.getters["motherEmploymentHistory/MonthlyIncome"];
        obj.FixPhoneNo = this.$store.getters["motherContactDetails/FixPhoneNo"];
        obj.MobilePhoneNo = this.$store.getters["motherContactDetails/MobilePhoneNo"];
        obj.FaxNo = this.$store.getters["motherContactDetails/FaxNo"];
        obj.Email = this.$store.getters["motherContactDetails/Email"];
        obj.NationalityId = this.$store.getters["motherPersonalDetails/Nationality"];
        obj.AddressId = this.$store.getters["motherPersonalDetails/PersonalAddress"];
        return obj;
      },
    },
    GuardianContactInfo: {
      get: function() {
        let obj = {};
        obj.IdentityNo = this.$store.getters["guardianPersonalDetails/IdentityNo"];
        obj.IdentityNoOther = this.$store.getters["guardianPersonalDetails/IdentityNoOther"];
        obj.FirstName = this.$store.getters["guardianPersonalDetails/FirstName"];
        obj.MonthlyIncome = this.$store.getters["guardianEmploymentHistory/MonthlyIncome"];
        obj.FixPhoneNo = this.$store.getters["guardianContactDetails/FixPhoneNo"];
        obj.MobilePhoneNo = this.$store.getters["guardianContactDetails/MobilePhoneNo"];
        obj.FaxNo = this.$store.getters["guardianContactDetails/FaxNo"];
        obj.Email = this.$store.getters["guardianContactDetails/Email"];
        obj.NationalityId = this.$store.getters["guardianPersonalDetails/Nationality"];
        obj.AddressId = this.$store.getters["guardianPersonalDetails/PersonalAddress"];
        obj.RelationshipId = this.$store.getters["guardianPersonalDetails/Relationship"];
        return obj;
      },
    },
    RelationshipId: {
      get: function () {
        return this.$store.getters[this.others + "PersonalDetails/Relationship"];
      },
      set: function (value) {
        this.$store.dispatch(this.others + "PersonalDetails/updateRelationship", value);
      },
    },
    ProgramId: {
      get: function() {
        return this.$store.getters["appProposedStudy/Programme"];
      },
      set: function(value) {
        this.$store.dispatch("appProposedStudy/updateProgramme", value);
      }
    },
    IdentityNoFather: {
      get: function () {
        return this.$store.getters["fatherPersonalDetails/IdentityNo"];
      },
    },
    IdentityNoMother: {
      get: function () {
        return this.$store.getters["motherPersonalDetails/IdentityNo"];
      },
    },
    IdentityNoGuardian: {
      get: function () {
        return this.$store.getters["guardianPersonalDetails/IdentityNo"];
      },
    },
    IdentityNoGuarantor1: {
      get: function () {
        return this.$store.getters["guarantor1PersonalDetails/IdentityNo"];
      },
    },
    IdentityNoGuarantor2: {
      get: function () {
        return this.$store.getters["guarantor2PersonalDetails/IdentityNo"];
      },
    },
    guarantorAgeEligibility: {
      get: function() {
        return this.realGuarantorAgeEligibility();
      },
    },
    guarantorEligibility: {
      get: function() {
        return this.realGuarantorEligibility();
      },
    },
    guarantorIncomeEligibility: {
      get: function() {
        return this.realGuarantorIncomeEligibility();
      },
    },
    CountryId1: {
      get: function () {
        return this.$store.getters["appProposedStudy/Country1"];
      },
      set: function(value) {
        this.$store.dispatch("appProposedStudy/updateCountry1", value);
      }
    },
    RelationshipIdV4: {
      get: function() {
        return this.$store.getters["appPersonalDetails/RelationshipV4"];
      },
      set: function(value) {
        this.$store.dispatch("appPersonalDetails/updateRelationshipV4", value);
      }
    },
  },
  methods: {
    delay(milliseconds) {
      return new Promise(resolve => {
        setTimeout(resolve, milliseconds);
      });
    },
    GetPersonalDetails() {
      let fN = 'GetPersonalDetails: ';
      this.$API
        .get(this.$PersonalDetails + "/" + this.others, { withCredentials: true, })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.FirstName = this.info.FirstName;
            this.LastName = this.info.LastName;
            this.Title = this.info.Title;
            this.IdentityNo = this.info.IdentityNo;
            this.IdentityNoOther = this.info.IdentityNoOther;
            this.RelationshipIdGuarantor = this.info.RelationshipId;
            let arr = _.filter(this.Relationship, ['Id', this.RelationshipIdGuarantor]);
            if (0 < arr.length) {
              this.RelationshipName = {};
              this.RelationshipName.Name = arr[0].Name;
            }
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetEmploymentHistory() {
      this.$API
        .get(this.$EmploymentHistory + "/" + this.others, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.MonthlyIncome = this.info.MonthlyIncome;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetBankDetails() {
      this.$API
        .get(this.$BankDetails, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            this.BankId = this.info.BankId;
            this.AccountNo = this.info.AccountNo;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getProposedStudy() {
      let fN = 'getProposedStudy: ';
      return this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data));
            this.CountryId1 = response.data.CountryId1;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async getRelationship() {
      let fN = 'getRelationship: ';
      var guardianRelationshipId = 0;
      for (var i = 0; i < 30; i++) {
        guardianRelationshipId = this.GuardianContactInfo.RelationshipId;
        await this.delay(100);
        if (0 < guardianRelationshipId) {
          break;
        } 
      }
      return this.$API
        .get(this.$Relationship, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            let arr = _.filter(response.data, ({Id}) => Id === 16 || Id === 17 || Id === guardianRelationshipId);
            this.Relationship = _.orderBy(arr, ["Name", "asc"]);
            // A guarantor must have a Malaysian Identity Number
            if ('' == this.IdentityNoMother) {
              _.remove(this.Relationship, { Id: 16, });
            }
            if (null == this.IdentityNoFather) {
              _.remove(this.Relationship, { Id: 17, });
            }
            if (null == this.IdentityNoGuardian) {
              _.remove(this.Relationship, { Id: guardianRelationshipId, });
            }
            this.HTECHLogger(this.sCFN + fN + 'this.Relationship = ' + JSON.stringify(this.Relationship))
          }
        });
    },
    async readConfig() {
      let fN = 'readConfig: ';
      return this.$API
        .get(this.$GetConfGeneral, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            //this.HTECHLogger(this.sCFN + fN + 'response.data = ' + JSON.stringify(response.data))
            let arr = _.filter(response.data, ({Name}) => Name === 'Guarantor');
            try {
              let jsonObject = JSON.parse(arr[0].JsonData)
              //this.HTECHLogger(this.sCFN + fN + 'jsonObject = ' + JSON.stringify(jsonObject))
              //this.HTECHLogger(this.sCFN + fN + 'this.CountryId1 = ' + this.CountryId1)
              if (130 == this.CountryId1) {
                this.guarantorMaxAge = jsonObject.Local.MaxAge;
                this.guarantorMinMonthlyIncome = jsonObject.Local.MinMonthlyIncome;
              } else {
                this.guarantorMaxAge = jsonObject.Abroad.MaxAge;
                this.guarantorMinMonthlyIncome = jsonObject.Abroad.MinMonthlyIncome;
              }
            } catch(e) {
                this.guarantorMaxAge = 0;
                this.guarantorMinMonthlyIncome = 0;
                this.guarantorMaxAge = 0;
                this.guarantorMinMonthlyIncome = 0;
            }
          }
        });
    },
    realGuarantorAgeEligibility() {
      let fN = 'guarantorAgeEligibility: ';
      let identityNo = this.IdentityNo;
      if (!this.IsIdentityValid(identityNo)) {
        return false;
      }
      var birthYear = identityNo.substring(0, 2);
      var yearInt = parseInt(birthYear);
      //this.HTECHLogger(this.sCFN + fN + 'yearInt = ' + yearInt)
      if (yearInt >= 30) 
        birthYear = "19" + birthYear;
      else
        birthYear = "20" + birthYear;
      let currentYear =  new Date().getFullYear();
      let age = currentYear - parseInt(birthYear);
      let parentsList = [];
      parentsList.push(this.IdentityNoFather);
      parentsList.push(this.IdentityNoMother);
      //this.HTECHLogger(this.sCFN + fN + 'parentsList = ' + JSON.stringify(parentsList))
      this.guarantorAgeEligibilityResult = 0;
      if (this.guarantorMaxAge >= age) {
        this.guarantorAgeEligibilityResult = 1;
        return true;
      } else {
        if (parentsList.includes(identityNo)) {
          this.guarantorAgeEligibilityResult = 1;
          return true;
        } else {
          this.guarantorAgeEligibilityResult = 0;
          this.guarantorAgeEligibilityRemark = 'Umur penjamin ' + age + ' melebihi had umur ' + this.guarantorMaxAge;
          return false;
        }
      }
    },
    realGuarantorEligibility() {
      let fN = 'guarantorEligibility: ';
      let parentsList = [];
      parentsList.push(this.IdentityNoFather);
      parentsList.push(this.IdentityNoMother);
      let guarantorList = [];
      if (0 < this.IdentityNoGuarantor1.length) {
        guarantorList.push(this.IdentityNoGuarantor1);
      }
      if (0 < this.IdentityNoGuarantor2.length) {
        guarantorList.push(this.IdentityNoGuarantor2);
      }
      this.guarantorEligibilityValidationResult = 0;
      let noOfParentsGuarantor = 0;
      for (let i = 0; i < guarantorList.length; i++) {
        if (parentsList.includes(guarantorList[i])) {
          noOfParentsGuarantor++;
        }
      }
      if (1 == noOfParentsGuarantor) {
        this.guarantorEligibilityValidationResult = 1;
        return true;
      }
      if (1 < noOfParentsGuarantor) {
        this.guarantorEligibilityValidationRemark = 'Hanya seorang dari ibu/bapa boleh menjadi penjamin';
        this.guarantorEligibilityValidationResult = 0;
        return false;
      }
      if (0 == noOfParentsGuarantor) {
        this.guarantorEligibilityValidationResult = 1;
        return true;
      }
      this.guarantorEligibilityValidationResult = 0;
      return false;
    },
    realGuarantorIncomeEligibility() {
      let fN = 'guarantorIncomeEligibility: ';
      this.guarantorIncomeEligibilityResult = 0;
      if (this.guarantorMinMonthlyIncome <= parseInt(this.MonthlyIncome)) {
        this.guarantorIncomeEligibilityResult = 1;
        return true;
      }
      this.guarantorIncomeEligibilityRemark = 'Pendapatan penjamin ' + this.MonthlyIncome + ' kurang daripada ' + this.guarantorMinMonthlyIncome;
      return false;
    },
    replaceInvertedComma() {
      let fN = 'replaceInvertedComma: ';
      this.FirstName = this.FirstName.replace("`","'");
      const isNumber = /\d/.test(this.FirstName);
      if (true == isNumber) {
        return false;
      } else {
        return true;
      }
    },
    async getAddressPersonal(others) {
      let fN = 'getAddressPersonal: ';
      this.HTECHLogger(this.sCFN + fN + 'others = ' + others)
      return this.$API
        .get(this.$PersonalAddress + "/" + others, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && this.info != null) {
            if ('father' === others) {
              this.FatherContactInfo.AddressId = this.info.Id;
              this.FatherContactInfo.Address1 = null != this.info.Address1 ? this.info.Address1.toUpperCase() : this.info.Address1;
              this.FatherContactInfo.Address2 = null != this.info.Address2 ? this.info.Address2.toUpperCase() : this.info.Address2;
              this.FatherContactInfo.Address3 = null != this.info.Address3 ? this.info.Address3.toUpperCase() : this.info.Address3;
              this.FatherContactInfo.Postcode = null != this.info.Postcode ? this.info.Postcode.toUpperCase() : this.info.Postcode;
              this.FatherContactInfo.CityId = this.info.CityId;
              this.FatherContactInfo.CityName = null != this.info.CityName ? this.info.CityName.toUpperCase() : this.info.CityName;
              this.FatherContactInfo.StateId = this.info.StateId;
              this.FatherContactInfo.StateName = null != this.info.StateName ? this.info.StateName.toUpperCase() : this.info.StateName;
              this.FatherContactInfo.OtherStateName = null != this.info.OtherStateName ? this.info.OtherStateName.toUpperCase() : this.info.OtherStateName;
              this.FatherContactInfo.CountryId = this.info.CountryId;
              this.FatherContactInfo.CountryName = null != this.info.CountryName ? this.info.CountryName.toUpperCase() : this.info.CountryName;
            }
            if ('mother' === others) {
              this.MotherContactInfo.AddressId = this.info.Id;
              this.MotherContactInfo.Address1 = null != this.info.Address1 ? this.info.Address1.toUpperCase() : this.info.Address1;
              this.MotherContactInfo.Address2 = null != this.info.Address2 ? this.info.Address2.toUpperCase() : this.info.Address2;
              this.MotherContactInfo.Address3 = null != this.info.Address3 ? this.info.Address3.toUpperCase() : this.info.Address3;
              this.MotherContactInfo.Postcode = null != this.info.Postcode ? this.info.Postcode.toUpperCase() : this.info.Postcode;
              this.MotherContactInfo.CityId = this.info.CityId;
              this.MotherContactInfo.CityName = null != this.info.CityName ? this.info.CityName.toUpperCase() : this.info.CityName;
              this.MotherContactInfo.StateId = this.info.StateId;
              this.MotherContactInfo.StateName = null != this.info.StateName ? this.info.StateName.toUpperCase() : this.info.StateName;
              this.MotherContactInfo.OtherStateName = null != this.info.OtherStateName ? this.info.OtherStateName.toUpperCase() : this.info.OtherStateName;
              this.MotherContactInfo.CountryId = this.info.CountryId;
              this.MotherContactInfo.CountryName = null != this.info.CountryName ? this.info.CountryName.toUpperCase() : this.info.CountryName;
            }
            if (('father' != others) && ('mother' != others)) {
              this.GuardianContactInfo.AddressId = this.info.Id;
              this.GuardianContactInfo.Address1 = null != this.info.Address1 ? this.info.Address1.toUpperCase() : this.info.Address1;
              this.GuardianContactInfo.Address2 = null != this.info.Address2 ? this.info.Address2.toUpperCase() : this.info.Address2;
              this.GuardianContactInfo.Address3 = null != this.info.Address3 ? this.info.Address3.toUpperCase() : this.info.Address3;
              this.GuardianContactInfo.Postcode = null != this.info.Postcode ? this.info.Postcode.toUpperCase() : this.info.Postcode;
              this.GuardianContactInfo.CityId = this.info.CityId;
              this.GuardianContactInfo.CityName = null != this.info.CityName ? this.info.CityName.toUpperCase() : this.info.CityName;
              this.GuardianContactInfo.StateId = this.info.StateId;
              this.GuardianContactInfo.StateName = null != this.info.StateName ? this.info.StateName.toUpperCase() : this.info.StateName;
              this.GuardianContactInfo.OtherStateName = null != this.info.OtherStateName ? this.info.OtherStateName.toUpperCase() : this.info.OtherStateName;
              this.GuardianContactInfo.CountryId = this.info.CountryId;
              this.GuardianContactInfo.CountryName = null != this.info.CountryName ? this.info.CountryName.toUpperCase() : this.info.CountryName;

            }
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    async setRelationshipIdGuarantor(event) {
      let fN = 'setRelationshipIdGuarantor: ';
      //this.HTECHLogger(this.sCFN + fN + 'event = ' + JSON.stringify(event))
      //this.HTECHLogger(this.sCFN + fN + 'this.others = ' + this.others)
      //this.HTECHLogger(this.sCFN + fN + 'GuardianContactInfo = ' + JSON.stringify(this.GuardianContactInfo))
      if (null !== event.value) {
        this.RelationshipIdGuarantor = event.value.Id;
        this.RelationshipName = {};
        this.RelationshipName.Name = event.value.Name;
        this.RelationshipId = this.RelationshipIdGuarantor;
        if (this.$ProgramIdYTP == this.ProgramId) {
          this.RelationshipIdV4 = this.RelationshipId;
        }
        if (17 == this.RelationshipIdGuarantor) {
          await this.getAddressPersonal('father');
          //this.HTECHLogger(this.sCFN + fN + 'father | ' + JSON.stringify(this.FatherContactInfo))
          this.IdentityNo = this.FatherContactInfo.IdentityNo;
          this.IdentityNoOther = this.FatherContactInfo.IdentityNoOther;
          this.FirstName = this.FatherContactInfo.FirstName;
          this.MonthlyIncome = this.FatherContactInfo.MonthlyIncome;
          this.$store.dispatch(this.others + "ContactDetails/updateEmail", this.FatherContactInfo.Email);
          this.$store.dispatch(this.others + "ContactDetails/updateFixPhoneNo", this.FatherContactInfo.FixPhoneNo);
          this.$store.dispatch(this.others + "ContactDetails/updateMobilePhoneNo", this.FatherContactInfo.MobilePhoneNo);
          this.$store.dispatch(this.others + "PersonalDetails/updatePersonalAddress", this.FatherContactInfo.AddressId);
          this.$store.dispatch(this.others + "PersonalAddress/updateId", this.FatherContactInfo.AddressId);
          this.$store.dispatch(this.others + "PersonalAddress/updateAddress1", this.FatherContactInfo.Address1);
          this.$store.dispatch(this.others + "PersonalAddress/updateAddress2", this.FatherContactInfo.Address2);
          this.$store.dispatch(this.others + "PersonalAddress/updateAddress3", this.FatherContactInfo.Address3);
          this.$store.dispatch(this.others + "PersonalAddress/updatePostcode", this.FatherContactInfo.Postcode);
          this.$store.dispatch(this.others + "PersonalAddress/updateCity", this.FatherContactInfo.City);
          this.$store.dispatch(this.others + "PersonalAddress/updateState", this.FatherContactInfo.State);
          this.$store.dispatch(this.others + "PersonalAddress/updateCountry", this.FatherContactInfo.CountryId);
          this.$store.dispatch(this.others + "PersonalAddress/updateCityName", this.FatherContactInfo.CityName);
          this.$store.dispatch(this.others + "PersonalAddress/updateStateName", this.FatherContactInfo.StateName);
          this.$store.dispatch(this.others + "PersonalAddress/updateOtherStateName", this.FatherContactInfo.OtherStateName);
          this.$store.dispatch(this.others + "PersonalAddress/updateCountryName", this.FatherContactInfo.CountryName);
        }
        if (16 == this.RelationshipIdGuarantor) {
          await this.getAddressPersonal('mother');
          //this.HTECHLogger(this.sCFN + fN + 'mother | ' + JSON.stringify(this.MotherContactInfo))
          this.IdentityNo = this.MotherContactInfo.IdentityNo;
          this.IdentityNoOther = this.MotherContactInfo.IdentityNoOther;
          this.FirstName = this.MotherContactInfo.FirstName;
          this.MonthlyIncome = this.MotherContactInfo.MonthlyIncome;
          this.$store.dispatch(this.others + "ContactDetails/updateEmail", this.MotherContactInfo.Email);
          this.$store.dispatch(this.others + "ContactDetails/updateFixPhoneNo", this.MotherContactInfo.FixPhoneNo);
          this.$store.dispatch(this.others + "ContactDetails/updateMobilePhoneNo", this.MotherContactInfo.MobilePhoneNo);
          this.$store.dispatch(this.others + "PersonalDetails/updatePersonalAddress", this.MotherContactInfo.AddressId);
          this.$store.dispatch(this.others + "PersonalAddress/updateId", this.MotherContactInfo.AddressId);
          this.$store.dispatch(this.others + "PersonalAddress/updateAddress1", this.MotherContactInfo.Address1);
          this.$store.dispatch(this.others + "PersonalAddress/updateAddress2", this.MotherContactInfo.Address2);
          this.$store.dispatch(this.others + "PersonalAddress/updateAddress3", this.MotherContactInfo.Address3);
          this.$store.dispatch(this.others + "PersonalAddress/updatePostcode", this.MotherContactInfo.Postcode);
          this.$store.dispatch(this.others + "PersonalAddress/updateCity", this.MotherContactInfo.City);
          this.$store.dispatch(this.others + "PersonalAddress/updateState", this.MotherContactInfo.State);
          this.$store.dispatch(this.others + "PersonalAddress/updateCountry", this.MotherContactInfo.CountryId);
          this.$store.dispatch(this.others + "PersonalAddress/updateCityName", this.MotherContactInfo.CityName);
          this.$store.dispatch(this.others + "PersonalAddress/updateStateName", this.MotherContactInfo.StateName);
          this.$store.dispatch(this.others + "PersonalAddress/updateOtherStateName", this.MotherContactInfo.OtherStateName);
          this.$store.dispatch(this.others + "PersonalAddress/updateCountryName", this.MotherContactInfo.CountryName);
        }
        if ((17 != this.RelationshipIdGuarantor)
         && (16 != this.RelationshipIdGuarantor)) {
          //this.HTECHLogger(this.sCFN + fN + 'not father & not mother | this.RelationshipIdGuarantor = ' + this.RelationshipIdGuarantor)
          this.IdentityNo = this.GuardianContactInfo.IdentityNo;
          this.IdentityNoOther = this.GuardianContactInfo.IdentityNoOther;
          this.FirstName = this.GuardianContactInfo.FirstName;
          this.MonthlyIncome = this.GuardianContactInfo.MonthlyIncome;
          this.$store.dispatch(this.others + "ContactDetails/updateEmail", this.GuardianContactInfo.Email);
          this.$store.dispatch(this.others + "ContactDetails/updateFixPhoneNo", this.GuardianContactInfo.FixPhoneNo);
          this.$store.dispatch(this.others + "ContactDetails/updateMobilePhoneNo", this.GuardianContactInfo.MobilePhoneNo);
          this.$store.dispatch(this.others + "PersonalDetails/updatePersonalAddress", this.GuardianContactInfo.AddressId);
          this.$store.dispatch(this.others + "PersonalAddress/updateAddress1", this.GuardianContactInfo.Address1);
          this.$store.dispatch(this.others + "PersonalAddress/updateAddress2", this.GuardianContactInfo.Address2);
          this.$store.dispatch(this.others + "PersonalAddress/updateAddress3", this.GuardianContactInfo.Address3);
          this.$store.dispatch(this.others + "PersonalAddress/updatePostcode", this.GuardianContactInfo.Postcode);
          this.$store.dispatch(this.others + "PersonalAddress/updateCity", this.GuardianContactInfo.City);
          this.$store.dispatch(this.others + "PersonalAddress/updateState", this.GuardianContactInfo.State);
          this.$store.dispatch(this.others + "PersonalAddress/updateCountry", this.GuardianContactInfo.CountryId);
          this.$store.dispatch(this.others + "PersonalAddress/updateCityName", this.GuardianContactInfo.CityName);
          this.$store.dispatch(this.others + "PersonalAddress/updateStateName", this.GuardianContactInfo.StateName);
          this.$store.dispatch(this.others + "PersonalAddress/updateOtherStateName", this.GuardianContactInfo.OtherStateName);
          this.$store.dispatch(this.others + "PersonalAddress/updateCountryName", this.GuardianContactInfo.CountryName);
        }
      }
      if (null === event.value) {
        this.RelationshipIdGuarantor = 0;
        this.RelationshipName = null;
      }
    },
    wasBornBefore1977(identityNo) {
      let fN = 'wasBornBefore1977: ';
      if (!this.IsIdentityValid(identityNo)) {
        return false;
      }
      var birthYear = identityNo.substring(0, 2);
      var yearInt = parseInt(birthYear);
      //this.HTECHLogger(this.sCFN + fN + 'yearInt = ' + yearInt)
      if (yearInt >= 30) 
        birthYear = "19" + birthYear;
      else
        birthYear = "20" + birthYear;
      if (1977 >= parseInt(birthYear)) {
        return true;
      }
      return false;
    },
  },
};
</script>